import { useMutation } from '@tanstack/react-query';
import { XHRClient } from '../client';
import { ENDPOINTS } from '../endpoints';

interface SearchPositionRequest {
  address: string;
}

interface SearchPositionResponse {
  success: boolean;
  address: string;
  latitude: number;
  longitude: number;
}

export const useSearchPositionMutation = () => {
  return useMutation<SearchPositionResponse, Error, SearchPositionRequest>({
    mutationFn: async (data: SearchPositionRequest) => {
      const response = await XHRClient.post<SearchPositionResponse>(
        ENDPOINTS.geo.searchPosition,
        data
      );
      return response.data;
    },
  });
};
